
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"34","height":"34","rx":"3","fill":"#D50072"}}),_c('path',{attrs:{"d":"M5.33 7.225v19.562h11.943c7.878 0 11.295-4.213 11.295-9.8 0-5.565-3.417-9.762-11.295-9.762H5.33z","fill":"#fff"}}),_c('path',{attrs:{"d":"M6.621 8.459h10.654c7.23 0 10.002 3.77 10.002 8.527 0 5.704-3.87 8.566-10.002 8.566H6.62V8.46zm1.033.986v15.122h9.62c5.81 0 8.97-2.585 8.97-7.58 0-5.134-3.426-7.542-8.97-7.542h-9.62z","fill":"#000"}}),_c('path',{attrs:{"d":"M8.945 18.098h3.08v5.235h-3.08v-5.235zm1.539-.809c1.057 0 1.914-.819 1.914-1.828 0-1.01-.857-1.828-1.914-1.828s-1.914.819-1.914 1.828c0 1.01.857 1.828 1.914 1.828z","fill":"#000"}}),_c('path',{attrs:{"d":"M18.483 16.316v.848H16.29v-3.401h2.124v.847h-1.237v.394h1.17v.847h-1.17v.466h1.307zm.384.848l1.074-3.403h1.262l1.074 3.403h-.924l-.201-.658h-1.16l-.203.658h-.922zm1.384-1.505h.643l-.295-.96h-.054l-.294.96zm2.472-1.897h.888v2.555h1.314c-.36-4.636-4.178-5.638-7.65-5.638h-3.7v3.085h.548c.998 0 1.618.646 1.618 1.686 0 1.074-.605 1.714-1.618 1.714h-.547v6.171h3.7c5.64 0 7.605-2.502 7.675-6.171h-2.228v-3.402zm-9.148.849v1.706h.548c.38 0 .731-.105.731-.867 0-.744-.39-.84-.73-.84h-.549z","fill":"#D50072"}})])
          )
        }
      }
    